import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MsalService } from '@azure/msal-angular';

export const SESSION_EXPIRED_TITLE_ID = 'session-expired-dialog-title';

@Component({
  selector: 'app-session-expired-dialog',
  templateUrl: './session-expired-dialog.component.html',
  styleUrls: ['./session-expired-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
})
export class SessionExpiredDialogComponent {
  private readonly msalService = inject(MsalService);

  readonly titleId = SESSION_EXPIRED_TITLE_ID;
  readonly isRedirecting = signal(false);

  onSignIn(): void {
    this.isRedirecting.set(true);
    // A silent re-login would hand back the same cached token, so sign out first. MSAL returns to the
    // current page, where MsalGuard starts a fresh sign-in.
    this.msalService.logoutRedirect().subscribe({
      error: () => this.isRedirecting.set(false),
    });
  }
}
